import { render, staticRenderFns } from "./Trouble.vue?vue&type=template&id=cf4c6102&"
import script from "./Trouble.vue?vue&type=script&lang=js&"
export * from "./Trouble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports